/* Varkha floating WhatsApp + "Need help?" nudge */
(function () {
  var NUM = '919211993115';
  var NUDGE_AFTER = 120; // seconds on site (across pages) before the "Need help?" bubble
  if (window.Shopify && Shopify.designMode) return;
  if (document.getElementById('vk-wa')) return;

  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function track(ev, extra) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: ev, page_type: pageType() }, extra || {})); } catch (e) {}
  }
  function pageType() {
    var p = location.pathname;
    if (/\/products\//.test(p)) return 'product';
    if (/\/collections\//.test(p)) return 'collection';
    if (/\/cart/.test(p)) return 'cart';
    return p === '/' ? 'home' : 'other';
  }
  function productTitle() {
    var h = document.querySelector('.product-details h1');
    return h ? h.textContent.trim() : '';
  }
  function message(inCart) {
    var t = productTitle();
    if (t) return 'Hi Varkha, I need help with this product: ' + t + '\n' + location.origin + location.pathname;
    if (inCart) return 'Hi Varkha, I need help placing my order on varkha.in';
    return 'Hi Varkha, I need help choosing a design on varkha.in';
  }
  function waLink(inCart) { return 'https://wa.me/' + NUM + '?text=' + encodeURIComponent(message(inCart)); }

  var css = '' +
    '#vk-wa{position:fixed;right:14px;bottom:16px;z-index:25;display:flex;flex-direction:column;align-items:flex-end;gap:10px;transition:bottom .25s ease;font-family:inherit;pointer-events:none}#vk-wa .vk-wa__btn,#vk-wa.is-nudge .vk-wa__bub{pointer-events:auto}' +
    '#vk-wa:not(.is-on){display:none!important}' +
    '#vk-wa .vk-wa__btn{width:54px;height:54px;border-radius:50%;background:#25d366;display:flex;align-items:center;justify-content:center;box-shadow:0 8px 22px -6px rgba(0,0,0,.35);text-decoration:none;transition:transform .2s}' +
    '#vk-wa .vk-wa__btn:active{transform:scale(.94)}' +
    '#vk-wa .vk-wa__btn svg{width:30px;height:30px;fill:#fff}' +
    '#vk-wa .vk-wa__bub{position:relative;max-width:230px;background:#fff;color:#1f1b16;border-radius:16px 16px 4px 16px;padding:12px 30px 12px 14px;box-shadow:0 10px 28px -8px rgba(0,0,0,.3);font-size:13.5px;line-height:1.4;text-decoration:none;opacity:0;transform:translateY(8px);transition:opacity .3s,transform .3s;pointer-events:none}' +
    '#vk-wa.is-nudge .vk-wa__bub{opacity:1;transform:none;pointer-events:auto}' +
    '#vk-wa .vk-wa__bub b{display:block;font-size:14.5px;margin-bottom:2px}' +
    '#vk-wa .vk-wa__bub span{color:#1a7f5a;font-weight:600}' +
    '#vk-wa .vk-wa__x{position:absolute;top:4px;right:4px;width:26px;height:26px;border:0;background:none;color:#888;font-size:18px;line-height:1;cursor:pointer;padding:0}' +
    '#vk-wa.is-nudge .vk-wa__btn{animation:vkWaPulse 1.8s infinite}' +
    '@keyframes vkWaPulse{0%{box-shadow:0 0 0 0 rgba(37,211,102,.55)}70%{box-shadow:0 0 0 14px rgba(37,211,102,0)}100%{box-shadow:0 0 0 0 rgba(37,211,102,0)}}' +
    '@media(min-width:990px){#vk-wa{right:24px;bottom:24px}}' +
    '@media(prefers-reduced-motion:reduce){#vk-wa.is-nudge .vk-wa__btn{animation:none}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var icon = '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M16.04 3C8.86 3 3.03 8.82 3.03 16c0 2.3.6 4.53 1.74 6.5L3 29l6.68-1.75A12.94 12.94 0 0 0 16.04 29C23.2 29 29 23.18 29 16S23.2 3 16.04 3zm0 23.67c-1.98 0-3.920-.53-5.61-1.53l-.4-.24-3.97 1.04 1.06-3.86-.26-.4A10.63 10.63 0 0 1 5.37 16c0-5.88 4.79-10.67 10.67-10.670S26.7 10.12 26.7 16s-4.78 10.67-10.66 10.67zm5.85-7.99c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.5-.16-.72.16-.21.32-.82 1.04-1 1.25-.19.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.59-.95-.85-1.59-1.9-1.78-2.22-.19-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.72-1.73-.98-2.37-.26-.62-.52-.54-.72-.55h-.61c-.21 0-.56.08-.85.4-.29.32-1.12 1.09-1.12 2.66s1.15 3.09 1.31 3.3c.16.21 2.26 3.45 5.47 4.84.76.33 1.36.53 1.83.68.77.24 1.47.21 2.02.13.62-.09 1.89-.77 2.16-1.52.27-.75.27-1.39.19-1.52-.08-.13-.29-.21-.61-.37z"/></svg>';

  function build() {
    var w = document.createElement('div');
    w.id = 'vk-wa';
    w.innerHTML =
      '<a class="vk-wa__bub" target="_blank" rel="noopener" href="#"><b>Need help? 🙏</b>Chat with us on WhatsApp, we reply fast. <span>Chat now →</span></a>' +
      '<button class="vk-wa__x" type="button" aria-label="Close">×</button>' +
      '<a class="vk-wa__btn" target="_blank" rel="noopener" href="#" aria-label="Chat with Varkha on WhatsApp">' + icon + '</a>';
    // put close button inside bubble
    var bub = w.querySelector('.vk-wa__bub'); bub.appendChild(w.querySelector('.vk-wa__x'));
    document.body.appendChild(w);

    var inCart = false;
    function refreshLinks() {
      var l = waLink(inCart);
      w.querySelector('.vk-wa__btn').href = l;
      bub.href = l;
    }
    refreshLinks();

    w.querySelector('.vk-wa__btn').addEventListener('click', function () { refreshLinks(); track('whatsapp_click', { wa_source: w.classList.contains('is-nudge') ? 'button_nudged' : 'button' }); });
    bub.addEventListener('click', function (e) {
      if (e.target.closest('.vk-wa__x')) return;
      refreshLinks(); track('whatsapp_click', { wa_source: 'need_help_bubble' });
    });
    w.querySelector('.vk-wa__x').addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      w.classList.remove('is-nudge'); ss('vk_wa_closed', '1'); track('whatsapp_nudge_closed');
    });

    // keep clear of the sticky add-to-cart bar
    var waBtn = w.querySelector('.vk-wa__btn');
    function place() {
      // sit above the sticky add-to-cart bar as soon as it is shown (data-stuck="true")
      var bar = document.querySelector('.sticky-add-to-cart__bar');
      var off = innerWidth >= 990 ? 24 : 16;
      if (bar && bar.getAttribute('data-stuck') === 'true') {
        var r = bar.getBoundingClientRect();
        if (r.height > 0) off = Math.round(Math.max(r.height, innerHeight - r.top)) + 12;
      }
      w.style.bottom = off + 'px';
      // never cover a buy button: hide while Add to cart / Buy Now / sticky Add to cart is under the WhatsApp button
      var wr = waBtn.getBoundingClientRect(), clash = false;
      var tgt = { l: wr.left - 6, r: wr.right + 6, t: Math.min(wr.top, innerHeight - off - 54) - 6, b: Math.max(wr.bottom, innerHeight - off) + 6 };
      var bs = document.querySelectorAll('.product-details button[name="add"], .shiprocket-headless, .sticky-add-to-cart__bar button, .quick-add__button, .cart__ctas button');
      for (var i = 0; i < bs.length; i++) {
        var br = bs[i].getBoundingClientRect();
        if (br.height > 0 && br.width > 0 && br.bottom > tgt.t && br.top < tgt.b && br.right > tgt.l && br.left < tgt.r) { clash = true; break; }
      }
      w.style.visibility = clash ? 'hidden' : ''; w.style.opacity = clash ? '0' : '';
    }
    place(); setInterval(place, 250);
    addEventListener('resize', place); addEventListener('scroll', place, { passive: true });
    var sb = document.querySelector('.sticky-add-to-cart__bar');
    if (sb && window.MutationObserver) new MutationObserver(place).observe(sb, { attributes: true, attributeFilter: ['data-stuck'] });

    // time on site (only while the tab is visible), counted across pages
    var secs = +(ss('vk_wa_t') || 0);
    var shown = ss('vk_wa_shown') === '1';
    // WhatsApp button + bubble appear only after NUDGE_AFTER seconds on site
    function turnOn() { if (!w.classList.contains('is-on')) { w.classList.add('is-on'); place(); } }
    if (secs >= NUDGE_AFTER) turnOn();
    function nudge() {
      if (shown || ss('vk_wa_closed') === '1') return;
      shown = true; ss('vk_wa_shown', '1');
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { inCart = c.item_count > 0; }).catch(function () {}).then(function () {
        if (inCart) bub.querySelector('b').nextSibling.nodeValue = 'Stuck while ordering? Chat with us on WhatsApp. ';
        refreshLinks(); w.classList.add('is-nudge'); track('whatsapp_nudge_shown', { cart_has_items: inCart });
      });
    }
    setInterval(function () {
      if (document.visibilityState !== 'visible') return;
      secs++; if (secs % 5 === 0) ss('vk_wa_t', String(secs));
      if (secs >= NUDGE_AFTER) { turnOn(); nudge(); }
    }, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
})();
